import type { BRollItem } from '@goldcast/api/content';

export interface VideoOverlayTrack {
  id: string;
  name: string;
  thumbnailUrl: string;
  videoUrl: string;
  duration: number;
  tags: string[];
}

export const mapBRollItemToVideoOverlayTrack = (item: BRollItem): VideoOverlayTrack => {
  return {
    id: item.video_url,
    name: item.video_title,
    thumbnailUrl: item.video_preview_url,
    videoUrl: item.video_url,
    duration: item.duration,
    tags: item.tags
  };
};
